module.exports = __webpack_public_path__ + "static/media/number-4-normal.5ef49c60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/numbers/number-4-normal.svg
// module id = 1311
// module chunks = 0